<ng-template #productcartinfo>
    <div *ngIf="product" [formGroup]="ProductForm">
        <upp-form-image style="position: relative;">
            <upp-image uppDataid="productcart-image-photo"
                [value]="product.photo"
                crheight="200" 
                crwidth="200" 
                [readonly]="true" 
            ></upp-image>
    
            <ion-chip *ngIf="product.code" class="code">
                <ion-label>#{{product.code}}</ion-label>
            </ion-chip>
            <ion-chip uppDataid="productcart-price-info" *ngIf="select" class="price">
                <ion-label>
                    <span class="small">{{tr("@ticket_price_product_total")}}:</span><br/>
                    {{select.priceinfo.int}}<span class="decimal">,{{select.priceinfo.dec}}</span>{{tr('@currency')}}
                </ion-label>
            </ion-chip>
        </upp-form-image>     
    
        <upp-form-section *ngIf="product && !product.IsAvailable" fill="clear">
            <upp-form-warning uppDataid="productcart-unavailable-warning"
                color="warning"
                icon="close-circle-outline"
                title="{{tr('@ticket_product_not_available_title')}}"
                subtitle="{{tr('@ticket_product_not_available_message')}}"
            ></upp-form-warning>
        </upp-form-section>

        <upp-form-section *ngIf="product.description" title="{{tr('@ticket_product_description')}}">
            <ion-item>
                <p uppDataid="productcart-description-info" class="description">{{tr(product.description)}}</p>
            </ion-item>
        </upp-form-section>
    
        <upp-form-section fill="clear" title="{{tr('@ticket_product_notes')}}">
            <ion-item>
                <upp-textarea uppDataid="productcart-notes-text" [rows]="3" 
                    formControlName="comments" 
                    placeholder="{{tr('@ticket_product_notes_ph')}}"
                    title="{{tr('@ticket_product_notes')}}"
                ></upp-textarea>
            </ion-item>
        </upp-form-section>

        <upp-form-section *ngIf="product.IsGeneric || product.IsVarious || product.IsMarket || product.IsWeighted">
            <ion-item *ngIf="product.IsGeneric || product.IsVarious">
                <upp-input #genericpriceinput uppDataid="productcart-generic-price-text"
                    formControlName="price"
                    type="price"
                    placeholder="{{tr('@place_product_input_price_ph')}}"
                    title="{{tr('@place_product_input_price')}}"
                    [errornfo]="{
                        required: tr('@mandatory_field')
                    }"
                ></upp-input>
            </ion-item>
            <ion-radio-group *ngIf="product.IsGeneric || product.IsVarious" uppDataid="productcart-generic-type-radiogroup" formControlName="type">
                <ion-item lines="full">
                    <ion-label>{{tr('@place_generic_type_bar')}}</ion-label>
                    <ion-radio slot="end" uppDataid="productcart-generic-bar-radio" value="BAR"></ion-radio>
                </ion-item>
                <ion-item lines="none">
                    <ion-label>{{tr('@place_generic_type_kitchen')}}</ion-label>
                    <ion-radio slot="end" uppDataid="productcart-generic-kit-radio" value="KIT"></ion-radio>
                </ion-item>
            </ion-radio-group>
            <ion-item *ngIf="product.IsMarket">
                <upp-input #marketinput uppDataid="productcart-market-text" 
                    formControlName="market" 
                    type="price" 
                    placeholder="{{tr('@place_product_input_perkg_ph')}}" 
                    title="{{tr('@place_product_input_perkg')}}"
                    [errornfo]="{ 
                        required: tr('@mandatory_field') 
                    }"
                ></upp-input>                    
            </ion-item>
            <ion-item *ngIf="product.IsWeighted">
                <upp-scale-input uppDataid="productcart-weight-text"
                    controlName="weight"
                    type="number"
                    placeholder="{{tr('@place_product_input_weight_ph')}}"
                    title="{{tr('@place_product_input_weight')}}"
                    [connection]="connection"
                    [device]="scale"
                    [errornfo]="{
                        required: tr('@mandatory_field')
                    }"
                ></upp-scale-input>
            </ion-item>
        </upp-form-section>            
    </div>
</ng-template>

<ng-template #productcartselect>
    <ng-container *ngIf="product">
        <ng-container *ngFor="let _category of product.categories; trackBy: CategoryTrack">
            <upp-form-section *ngIf="_category.Suitable" title="{{tr(_category.name)}}">
                
                <!-- SINGLE CATEGORY (RADIO SELECT)-->
                <ng-container *ngIf="_category.type === 'SINGLE'">
                    <ion-radio-group uppDataid="productcart-option-radiogroup" [value]="_category.SingleOption" (ionChange)="OnSingleSelected($event, _category)">                        
                        <ng-container *ngFor="let _option of _category.options; trackBy: OptionTrack">
                            <ion-item class="option" [class.unavailable]="!_option.IsAvailable" lines="full">
                                <ion-icon slot="start"
                                    [name]="ExpandedOption(_option) ? 'help-circle' : 'help-circle-outline'"
                                    (click)="OnOptionExpand($event, _option)"
                                ></ion-icon>
                                <ion-label>{{tr(_option.name)}}</ion-label>
                                <ion-radio
                                    [uppDataid]="'productcart-radio-' + (tr(_option.name) || '') + '-option'"
                                    slot="end"
                                    [disabled]="!_option.IsAvailable || _option.Disabled"
                                    [value]="_option"
                                ></ion-radio>
                            </ion-item>
                            <ion-item class="option" *ngIf="ExpandedOption(_option)" lines="full">
                                <ion-label class="description">{{tr(_option.description) || tr('@place_product_select_no_description')}}</ion-label>
                            </ion-item>
                        </ng-container>
                    </ion-radio-group>
                </ng-container>

                <!-- OTHER CATEGORY (CHECK SELECT)-->
                <ng-container *ngIf="_category.type !== 'SINGLE'">
                    <ng-container *ngFor="let _option of _category.options; trackBy: OptionTrack">
                        <ion-item class="option" [class.unavailable]="!_option.IsAvailable" lines="full">
                            <ion-icon slot="start"
                                [name]="ExpandedOption(_option) ? 'help-circle' : 'help-circle-outline'"
                                (click)="OnOptionExpand($event, _option)"
                            ></ion-icon>
                            <ion-label>{{tr(_option.name)}}</ion-label>
                            <ion-checkbox
                                [uppDataid]="'productcart-check-' + (tr(_option.name) || '') + '-option'"
                                slot="end"
                                [disabled]="!_option.IsAvailable || _option.Disabled"
                                [checked]="_option.Checked"
                                (ionChange)="OnOptionSelected($event, _option)"
                            ></ion-checkbox>
                        </ion-item>
                        <ion-item class="option" *ngIf="ExpandedOption(_option)" lines="full">
                            <ion-label class="description">{{tr(_option.description) || tr('@place_product_select_no_description')}}</ion-label>
                        </ion-item>
                    </ng-container>
                </ng-container>
            </upp-form-section>
        </ng-container>  
    </ng-container>
</ng-template>

<ng-template #productcartbrief>
    <ng-container *ngIf="product && select">
        <ng-container *ngIf="select.IsCompleted !== true">
            <upp-form-section uppDataid="productcart-completed-warning" fill="clear" title="{{tr('@ticket_options_for_product', [ tr(product.name) || '' ])}}">
                <upp-form-warning uppDataid="productcart-completed-warning" 
                    color="danger"
                    slot="end"
                    icon="warning-outline"
                    title="{{tr('@ticket_select_options_warning_title')}}"
                    subtitle="{{tr('@ticket_select_options_warning_message')}}"
                ></upp-form-warning>
            </upp-form-section>
        </ng-container>

        <ng-container *ngIf="select.IsCompleted === true">
            <upp-form-section uppDataid="productcart-completed-options" title="{{tr('@ticket_options_for_product', [ tr(product.name) || '' ])}}">
                <ion-item lines="none" style="border-bottom: 2px solid var(--ion-color-success);">
                    <ion-icon slot="start" color="success" name="wine-outline"></ion-icon>
                    <ion-label>
                        <b>{{tr(product.name)}}</b>
                    </ion-label>
                    <ion-label slot="end" style="text-align: right;">
                        <b>{{select.priceinfo.str || "0.00"}}{{tr('@currency')}}</b>
                    </ion-label>
                </ion-item>
                <ion-item *ngFor="let _option of select.options; trackBy: OptionTrack" lines="none">
                    <ion-icon slot="start" color="success" name="checkmark-circle-outline"></ion-icon>
                    <ion-label>
                        {{tr(_option.name)}}
                    </ion-label>
                    <ion-label slot="end" slot="end" style="text-align: right;">
                        <span *ngIf="_option.priceinfo.neg === false">+</span>
                        <span *ngIf="_option.priceinfo.neg !== false">-</span>
                        {{_option.priceinfo.str}}{{tr('@currency')}}
                    </ion-label>
                </ion-item>
                <ion-item lines="none" style="border-top: 2px solid var(--ion-color-success);">
                    <ion-label slot="start" color="success">{{tr('@ticket_product_total_price')}}</ion-label>
                    <ion-label slot="end" color="success" style="text-align: right;">
                        <b>{{select.priceinfo.str || "0.00"}}{{tr('@currency')}}</b>
                    </ion-label>                        
                </ion-item>
            </upp-form-section>
        </ng-container>
    </ng-container>
</ng-template>

<upp-visible-control mode="fill">
    <upp-panel *ngIf="ticket" [size]="view.Mobile ? 'auto' : 'large'">
        <upp-panel-header>
            <upp-header color="light" lines="success">
                <upp-header-title *ngIf="product">
                    {{ tr(product.name) }}
                    <span *ngIf="select">
                        <span class="price">{{select.priceinfo.int}},<span class="decimal">{{select.priceinfo.dec}}</span>{{tr('@currency')}}</span>
                    </span>
                </upp-header-title>
                <upp-header-button size="small" uppDataid="productcart-close-button" (click)="OnClose()">
                    <ion-icon name="close-outline"></ion-icon>
                </upp-header-button>
            </upp-header> 
        </upp-panel-header>
        <upp-panel-content>
            <upp-form *ngIf="!ChangeUpdate && ticket && product">
                <ng-container [ngTemplateOutlet]="productcartinfo"></ng-container>
                <ng-container [ngTemplateOutlet]="productcartselect"></ng-container>
                <ng-container [ngTemplateOutlet]="productcartbrief"></ng-container>

                <upp-form-buttons>
                    <ion-button uppDataid="productcart-update-button"
                        *ngIf="ticketproduct"
                        size="large"
                        fill="outline"
                        expand="block"
                        color="success"
                        [disabled]="!CanAccept"
                        (click)="OnUpdate()">
                        {{tr('@ticket_product_set_accept')}}
                    </ion-button>
                    <div style="position: relative;">
                        <ion-icon uppDataid="productcart-delone-button" 
                            *ngIf="!product.IsWeighted"
                            color="success" 
                            class="left" 
                            name="remove-circle-outline" 
                            [ngClass]="{ 'disabled': !CanDelItem }" 
                            (click)="OnDelItem($event)"
                        ></ion-icon>                    
                        <ion-button uppDataid="productcart-submit-button" 
                            size="large" 
                            fill="outline" 
                            expand="block" 
                            color="success" 
                            [disabled]="!CanAccept" 
                            (click)="OnInsert()">
                            {{ItemAcceptLabel}}
                        </ion-button>
                        <ion-icon uppDataid="productcart-addone-button" 
                            *ngIf="!product.IsWeighted"
                            color="success" 
                            class="right" 
                            name="add-circle-outline" 
                            [ngClass]="{ 'disabled': !CanAddItem }" 
                            (click)="OnAddItem($event)"
                        ></ion-icon>      
                    </div>
                    <ion-button uppDataid="productcart-cancel-button" 
                        expand="block" 
                        fill="clear" 
                        color="success" 
                        (click)="OnClose()">
                        {{tr('@ticket_product_add_cancel')}}
                    </ion-button>
                </upp-form-buttons>                     
            </upp-form>            
        </upp-panel-content>  
    </upp-panel>
</upp-visible-control>
